module.exports = __webpack_public_path__ + "img/logo_wellnessmetric.43a75ad7.svg";